import { ModalStep } from '@alltrails/modal';
import logCheckoutScreenDismissed from '@alltrails/amplitude/events/logCheckoutScreenDismissed';
import type PurchaseTier from '@alltrails/core/types/PurchaseTier';
import UpsellTrigger from '@alltrails/amplitude/enums/UpsellTrigger';
import CheckoutModalStepContent from './CheckoutModalStepContent';
import styles from './CheckoutModal.module.scss';

type Props = {
  closeModal: () => void;
  navigateToWelcome: () => void;
  onSuccess?: () => void;
  purchaseTier: PurchaseTier;
  trigger: UpsellTrigger;
};

// https://www.figma.com/design/dOj6Te4I0TVguYevn6Fj5g/Web-Checkout-Improvements?node-id=268-59621&m=dev
export default function CheckoutModalStep({ closeModal, navigateToWelcome, onSuccess, purchaseTier, trigger }: Props) {
  return (
    <ModalStep
      scrollContainerClassName={styles.scrollContainer}
      contentsClassName={styles.contentContainer}
      onCloseRequest={() => {
        logCheckoutScreenDismissed();
        closeModal();
      }}
      hideCloseButton
    >
      <CheckoutModalStepContent navigateToWelcome={navigateToWelcome} onSuccess={onSuccess} purchaseTier={purchaseTier} trigger={trigger} />
    </ModalStep>
  );
}
